import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export function imgSrc(v) {
  if (!v) return null;
  if (v.startsWith("http") || v.startsWith("/")) return v;
  return `${BACKEND}/api/files/${v}`;
}
